module.exports = __webpack_public_path__ + "static/img/capacitor_eletrolitico-1.b48d80f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/capacitor_eletrolitico-1.svg
// module id = AaHv
// module chunks = 0